export default {
  status: {
    success: 'No há datos para exibir.',
    error: 'Error ao carregar datos.',
  },
};
